import AppContainer from "../Structure/AppContainer";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import ajaxDeliveries from "../../util/remote/ajaxDeliveries";
const StationDeliveredFuelTable = () => {
  const station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const [loading, setLoading] = useState(false);
  const [fuelData, setFuelData] = useState([]);
  const fetchDeliveredFuel = async () => {
    setLoading(true);
    const data = { station_id: station_idd };
    const response = await ajaxDeliveries.station_total_delivered_per_fuel(
      data
    );
    if (response.status === "OK") {
      setFuelData(response.details);
    } else {
      toast.error(response.message || "Failed to load delivered fuel.");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchDeliveredFuel();
  }, [station_idd]);
  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered text-nowrap ">
          <thead>
            <tr>
              <th>#</th>
              <th>Fuel Name</th>
              <th>Total Delivered (Litres)</th>
            </tr>
          </thead>
          <tbody>
            {fuelData.length > 0 ? (
              fuelData.map((item, index) => (
                <tr key={item.fuel_id}>
                  <td>{index + 1}</td>
                  <td>{item.fuel_name}</td>
                  <td>{Number(item.total_quantity).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  {loading ? "Loading..." : "No data found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default StationDeliveredFuelTable;
